/**
 * @generated SignedSource<<64317f3791dd0e1fba8484688253d9fe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AutoRecordRuleLevel = "GROUP" | "USER" | "WORKSPACE";
import { FragmentRefs } from "relay-runtime";
export type StreamAutoRecordAutomationConfig_useAutoRecordReason_stream$data = {
  readonly autoRecordSetting: {
    readonly __typename: "NoteStreamStreamBasedAutoRecordSource";
    readonly creator: {
      readonly firstName: string;
      readonly fullName: string;
      readonly id: string;
      readonly isViewer: boolean;
    } | null;
    readonly value: boolean;
  } | {
    readonly __typename: "NoteStreamUserSettingsBasedAutoRecordEnableSource";
    readonly cannotBeRecordedReason: string | null;
    readonly rules: ReadonlyArray<{
      readonly autoRecordRuleUsers: ReadonlyArray<{
        readonly user: {
          readonly firstName: string;
          readonly fullName: string;
          readonly id: string;
          readonly isViewer: boolean;
        };
      }>;
      readonly ruleLevel: AutoRecordRuleLevel;
    }>;
    readonly users: ReadonlyArray<{
      readonly firstName: string;
      readonly fullName: string;
      readonly id: string;
      readonly isViewer: boolean;
    }>;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
  readonly " $fragmentType": "StreamAutoRecordAutomationConfig_useAutoRecordReason_stream";
};
export type StreamAutoRecordAutomationConfig_useAutoRecordReason_stream$key = {
  readonly " $data"?: StreamAutoRecordAutomationConfig_useAutoRecordReason_stream$data;
  readonly " $fragmentSpreads": FragmentRefs<"StreamAutoRecordAutomationConfig_useAutoRecordReason_stream">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "firstName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "fullName",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isViewer",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StreamAutoRecordAutomationConfig_useAutoRecordReason_stream",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "autoRecordSetting",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "creator",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "type": "NoteStreamStreamBasedAutoRecordSource",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "users",
              "plural": true,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AutoRecordRule",
              "kind": "LinkedField",
              "name": "rules",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "ruleLevel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "AutoRecordRuleUser",
                  "kind": "LinkedField",
                  "name": "autoRecordRuleUsers",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "User",
                      "kind": "LinkedField",
                      "name": "user",
                      "plural": false,
                      "selections": (v0/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cannotBeRecordedReason",
              "storageKey": null
            }
          ],
          "type": "NoteStreamUserSettingsBasedAutoRecordEnableSource",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};
})();

(node as any).hash = "7364b60ad75b3b76a102e88501751872";

export default node;
